module.exports = __webpack_public_path__ + "static/media/xaman-kyc-tag.40c02cc8.svg";